<div class="rating" [title]="ratingText">
  <div
    *ngFor="let star of generatedRatingStars"
    class="rating__svg-container"
    [class.rating__svg-container--filled]="star === 'filled'"
    [class.rating__svg-container--half]="star === 'half'"
    [innerHTML]="svgHtml | safeHtml"
    [aria-label]="'Star rating ' + ratingLevel"
  ></div>
</div>
